import { DEV_GATEWAY_ORIGIN } from './gateway-origins';
import { AppEnvironment } from './environment.model';

/**
 * Hosted DEV Static Web App. Served at `/`.
 */
export const environment: AppEnvironment = {
  production: true,
  name: 'dev',
  devRoleOverride: null,
  apiMode: 'prod',
  apiOrigin: DEV_GATEWAY_ORIGIN,
  authOrigin: DEV_GATEWAY_ORIGIN,
  apiBaseUrl: '/api',
  dealerApiBaseUrl: '/api/dealer',
  resolveApiBaseUrl: '/api/resolve',
  doriApiBaseUrl: 'https://dori-callback-uat.stealthmonitoring.dev',
  doriApiToken: '8bXXYpGtlvhF7NSoodPyV3eNSL2hcNwF',
  dealerEventsTop: 200,
  dealerBypassAllowedSitesFilter: false,
  resolveUrl: 'https://eventq-dev.ecamapps.net/resolve',
  resolveAppBaseUrl: 'https://eventq-dev.ecamapps.net/resolve',
  eventqAppBaseUrl: 'https://eventq-dev.ecamapps.net',
  sessionCookieDomain: '',
  refreshIntervalMs: 15000,
  eventRefreshIntervalMs: 5000,
  sharedWorkerUrl: '/workers/ebm-shared-worker.js',
  streaming: {
    initializeBaseUrl: 'https://streaming-tm-stg.ecamapps.net:3100',
    rtspUsername: 'rtsp',
    rtspPassword: 'rtsp',
    fallbackRtspUsername: 'user',
    fallbackRtspPassword: 'S2Password',
    fallbackRtspHost: '950hudsonrda.smisite.com',
  },
  okta: {
    issuer: 'https://garda.okta.com',
    clientId: '0oa28gd2etelygHbb0h8',
    callbackPath: 'sso/login',
    scopes: ['openid', 'profile', 'email'],
  },
  sts: {
    exchangePath: '/Auth/ExchangeEventq',
    audience: 'Stealth',
    scope: 'StealthApis',
  },
  features: {
    enableTabPopout: false,
    enforceArmDisarmRbac: true,
    useBackendPermissions: true,
    signalr: true,
    sharedWorker: true,
    broadcastChannel: true,
    maxOpenWorkTabs: 4,
  },
};
